module.exports = __webpack_public_path__ + "static/media/15327626_1641897976104660_1212887437_n.14a8350c.jpg";